import React from 'react';
import ListGroup from 'react-bootstrap/ListGroup';

import moment from 'moment';
import { extractRepoDetails } from './helpers';


const IssueEntry = ({ issue }) => {
  const { repositoryName, userName } = extractRepoDetails(issue.repository_url);
  const repositoryUrl = "https://github.com/" + userName + "/" + repositoryName;
  const htmlUrl = issue.html_url;
  const title = issue.title;

  const createdAt = moment(issue.created_at).fromNow();

  const poster = issue.user.login;

  return (
    <ListGroup.Item>
      <a href={repositoryUrl} target="_blank" rel="noopener noreferrer">{ userName }/{ repositoryName }</a>
      &nbsp;-&nbsp;
      <a href={ htmlUrl } target="_blank" rel="noopener noreferrer">{ title }</a>
      <br/>
      posted { createdAt } by { poster }
    </ ListGroup.Item>
  );
};

export default IssueEntry;
